<script>
import { ShadowRoot } from './../../libraries/ShadowRoot.js';
import { AppForms } from '../../libraries/AppForms.js';
import { InjectScript } from '../../libraries/InjectScript.js';
import { turpial } from '../../libraries/turpial.js';

import { StoreForm } from './StoreForm.js';
export let changeStep;
export let Data;
let has_chooser_plan_module = Data.has_chooser_plan_module ?? false;
let userFromCampaign = Data.userFromCampaign;
let is_online = Data.is_online ?? true;
let has_captcha = typeof Data.has_captcha === "undefined" ? false : Data.has_captcha;
export let errors;
let getMembership = ()=>{
    return tripod_register.membership;
}  

let host = "https://app.3pod.io/";
if(is_online === false){
    host = Data?.host_offline ?? "http://localhost/beta.3pod.io/"
}

let typeOfSignUp = Data.type ?? "default";
let lang = Data.lang;
let buttonSubmit = null;
let formLang = lang.forms.signIn;
let form = null;

//restore
StoreForm.update("dataForm", {}, $StoreForm?.dataForm);

function checkForm(data){
    let is_all_valid = true;
    data = data || {};

    // check empty inputs
    let checks = ["email", "password"];
    checks.map(( element )=>{        
        if(typeof data[element] !== "string"){
            is_all_valid = false;
        }
        if(data[element] === ""){
            is_all_valid = false;
        }
    });
    
    return is_all_valid;
}
window.user_signed = null;
function catchData(target, before){
    before = before||function(data){ return data; }
    errors.hide();
    let form = target;

    let data = AppForms.retrieve({
        targets: ".formElements",
        form: form,
    });

    if(checkForm(data) === false){ 
        AppForms.statusButton(buttonSubmit, "enabled");
        errors.showError(lang.errors.uncompleted);
        return;
    }

    data = before(data);    
    data.userFromCampaign = userFromCampaign;
    data.affiliate_email = Data?.affiliate ?? null;
    let dataForm = data;
    AppForms.statusButton(buttonSubmit, "disabled");

    let method = "POST";
    let connections = [
        host+"api/getPlans",
        host+"public/api/v1/signInUser"
    ];




    turpial.fetch({
        files: connections,
        method: method,
        type: "text",
        data: JSON.stringify(data),
        ready: (data)=>{
            // on default
            let plans = JSON.parse(data[0]).response[getMembership()];
            let response_data = JSON.parse(data[1]);
            const user = response_data.response;
            AppForms.statusButton(buttonSubmit, "enabled");

            // get data;
            dataForm.email = user.email
            dataForm.login_token = user.login_token
            dataForm.login_token2 = user.login_token2
            dataForm.subscriptions = user?.subscriptions ?? {};
            dataForm.stripe_account = user.stripe_account ?? "default";
            window.user_signed = user;

            StoreForm.update_raw((data)=>{
                data.global_vars.stripe_account = dataForm.stripe_account;
                return data;
            })

            

            if(response_data.status === "error"){
                errors.showError(response_data.message);
                return;
            }


            let available_to_register_campaign = response_data.response.available_to_register_campaign ?? null;
            if(available_to_register_campaign === false){
                errors.showError("No se puede asignar tu cuenta a esta campaña.");
                return;
            }


            let plans_selected = plans.filter(( plan )=>{
                // buscar entre los seleccionados en tripod_register
                if(typeof tripod_register.plans_selected.find(( selected )=>{
                    if(selected === plan.__id__){
                        return selected;
                    }
                }) !== "undefined"){
                    return plan;
                }
            })
            tripod_register.plans = plans;
            tripod_register.dataForm = dataForm;            

            tripod_register.plansFetched = plans_selected;

            StoreForm.update("plansFetched", plans_selected);
            StoreForm.update("plans", plans);
            StoreForm.update("dataForm", dataForm, $StoreForm?.dataForm);


            if(has_chooser_plan_module === true){
                
                changeStep("ChoosePlan");
                return;
            }
            changeStep("PaymentFunnels");            
        },
        onerror: (data)=>{
            console.error(data)
            AppForms.statusButton(buttonSubmit, "enabled");
        }
    });

}

tripod_register.submit = (token)=>{
    catchData(form, function(data){
        console.log("data-callback")
        let hcaptcha = $ShadowRoot.querySelector("iframe[data-hcaptcha-response]");
        data.captcha = hcaptcha.getAttribute("data-hcaptcha-response")
        return data;
    });
}

if(has_captcha){
    InjectScript("https://js.hcaptcha.com/1/api.js", {
        attrs: {
            async: "",
            defer: "",
        },
        onload: ()=>{
            hcaptcha.render(buttonSubmit, {
                sitekey: 'bf7e6dce-eb06-4ad7-8aa1-cddcbd4f365d',
                'data-callback': 'captchaSubmit',
            });
        }
    })
}
</script>
<header class="step-SignInForm--header">
    <h2 class="has-text-black fw700 font-size-24 title-first-step">
        {formLang.title}
    </h2>
    <p class="has-text-dark f200 subtitle-first-step">
        {@html formLang.subtitle}
    </p>                
</header>
<main class="step-SignInForm--container">
    <form class="columns is-multiline" action="" onsubmit="event.preventDefault()" method="POST" bind:this="{form}" on:submit|preventDefault="{(e)=>{ catchData(e.target) }}">
        <div class="field column is-12">
            <div class="control has-text-left">
                <label for="" class="fw600 label-text">{lang.forms.basic.email}</label>
                <input type="email" name="email" value="{$StoreForm?.dataForm["email"] ?? ""}" placeholder="E-mail" class="input formElements is-fullwidth" required>
            </div>
        </div>
        <div class="field column is-12">
            <div class="control has-text-left">
                <label for="" class="fw600 label-text">{lang.forms.basic.password} <span class="has-text-danger">*</span></label>
                <input type="password" value="{$StoreForm?.dataForm["password"] ?? ""}" name="password" placeholder="{lang.forms.basic.password}" class="input formElements is-fullwidth" required>
            </div>
        </div>
        <div class="field column is-12">
            <p class="is-underlined pointer under--navigation-back">
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <span on:click={changeStep("BasicForm")}>
                    {lang.goBack}
                </span>
            </p>
            <div class="buttons is-grouped is-centered submit-buttons-continue">
                <button bind:this={buttonSubmit} type="submit" data-size="invisible" data-callback="captchaSubmit" class="button is-fullwidth is-primary">
                    {formLang.button}
                </button>
            </div>
            <p class="">
                <a class="has-text-primary is-underlined" href="https://app.3pod.io/user/recover_password" target="_blank" rel="noopener noreferrer">
                    {lang?.sign_in_recover ?? "Olvidé mi contraseña"}
                </a>
            </p>
        </div>
    </form>
</main>
<style>
form{
    position: relative;
    padding: 1.75rem 2.25rem;
}
@media only screen and (max-width:768px){
    form{
        padding: 1.75rem 0rem;
    }
}
form .field{
    padding: 0.5rem 0.45rem;
}
form .field .control{
    text-align: left;
}
</style>